/*----------------------------------------
	Cart
----------------------------------------*/
jQuery(document).ready(function ($) {

    $('#btn-cnt').on('click', function(e) {
        $('.cart-drawer').slideUp();
    })

});